import {
  type ComponentProps,
  type LayoutData,
  Region,
} from "@enonic/react-components";

export const NewsArticleBodyLayout = ({
  component,
  meta,
}: ComponentProps<LayoutData>) => {
  return (
    <div className="article-content article-body">
      <Region
        data={component.regions.left.components}
        meta={meta}
        name="left"
      />
      <Region
        data={component.regions.right.components}
        meta={meta}
        name="right"
      />
    </div>
  );
};
